import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, AfterContentChecked, AfterViewInit, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { User } from '@auth0/auth0-angular';
import { FieldSettingsModel, MenuAllModule, MenuEventArgs, MenuModule } from '@syncfusion/ej2-angular-navigations';
import { filter, map, startWith } from 'rxjs/operators';
import { SharedService } from '../shared/service/shared.service';
import { OcadoAuthService } from '../shared/service/auth.service';
import { NgClass, NgStyle } from '@angular/common';
import { DialogComponent, DialogModule, TooltipAllModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { LongTextPipe } from '../shared/pipes/long-text.pipe';
import { NotificationService } from '../shared/service/notification.service';
import { ButtonModule, ChipListModule } from '@syncfusion/ej2-angular-buttons';
import { CommonDialogComponent } from '../shared/components/common-dialog/common-dialog.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { promotionConstants } from '../shared/ocado-constants';
import { Subscription } from 'rxjs';
import { SummaryService } from '../summary/service/summary.service';
import { IndexedDBService } from '../shared/service/indexed-db.service';

@Component({
  selector: 'ocado-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  standalone: true,
  imports: [ DialogModule, TooltipModule, TooltipAllModule, MenuModule, MenuAllModule, RouterOutlet, LongTextPipe, NgClass, ButtonModule, CommonDialogComponent, ChipListModule, NgStyle, ReactiveFormsModule ]
})
export class LayoutComponent implements OnInit, AfterViewInit, AfterContentChecked, OnDestroy {

  @HostListener('document:click', [ '$event' ])
  onDocumentClick() {
    if (this.plusDialog) this.plusDialog = false;
  }

  @HostListener('window:beforeunload', [ '$event' ]) unloadTab($event: any): void {
    if (this.tabsList.length > 2 && this.tabsList.findIndex(tab => tab.url === 'promotion-detail' || tab.url === 'proposal-detail') >= 0) {
      for (let i = 2; i < this.tabsList.length; i++) {
        if (this.tabsList[ i ].url === 'promotion-detail') {
          this.indexedDBService.deleteData(this.tabsList[ i ].id, promotionConstants.promotionsStoreName);
        } else if (this.tabsList[ i ].url === 'proposal-detail') {
          this.indexedDBService.deleteData(this.tabsList[ i ].id, promotionConstants.proposalsStoreName);
        }
      }
    }
  }

  user!: User | null | undefined;

  @ViewChild('menuBar') public menuBar!: DialogComponent;
  // @ViewChild('saveFilterDialog') saveFilterDialog!: DialogComponent;
  promotionConstants = promotionConstants;
  previousTab!: MenuEventArgs;
  previousRouteIndex!: number;
  public showTab: boolean = true;
  public warningDialog: boolean = false;
  public tabLimitReached: boolean = false;
  public tabScreenLimitReached = new FormControl('');
  public tabScreenLimitReachedMsg: string = '';
  public closeIndex!: number;
  public notificationCount!: number;
  public currentViewId: number = -1;
  public isFormChange: boolean = false;
  plusDialog: boolean = false;
  dialogLeft: number = 0;
  public menuItems: any[] = [];
  clickedItem = '';
  draftStatus: boolean = false;
  saveFilterDlg: boolean = false;
  // filtrationFormGroup!: FormGroup<filtrationFormGroup>;

  public menuFields: FieldSettingsModel = {
    text: [ 'text', 'value' ],
    children: [ 'options' ]
  };
  filterQuery = btoa(JSON.stringify(promotionConstants.defaultFilter));
  tempColumn = this.ocadoAuthService.isStaff ? JSON.parse(JSON.stringify(promotionConstants.buyerColumnsList)) : JSON.parse(JSON.stringify(promotionConstants.supplierColumnsList));
  tabsList: any[] = [
    { text: "Dashboard", active: false, url: this.ocadoAuthService.isStaff ? 'buyer-dashboard' : 'supplier-dashboard' },
    { text: "Summary", active: false, url: 'summary', routeParam: [ { q: this.filterQuery, col: btoa(JSON.stringify(this.tempColumn.map((e: any) => ({ id: e.id, isVisible: e.isVisible })))) } ] }
  ];

  menuList: any[] = [];
  reportsList: any[] = [];

  tabScreenLimitReachedSubscription!: Subscription;
  newTabSubscription!: Subscription;
  routerEventsSubscription!: Subscription;
  queryParamsSubscription!: Subscription;
  promotionNameSubscription!: Subscription;
  deleteTabSubscription!: Subscription;
  currentViewIdSubscription!: Subscription;
  invalidProposalSubscription!: Subscription;
  checkFormChangeSubscription!: Subscription;
  connectToServerSentEventsSubscription!: Subscription;
  getApplicationListSubscription!: Subscription;

  constructor(private router: Router, private indexedDBService: IndexedDBService,
    public ocadoAuthService: OcadoAuthService, private activatedRoute: ActivatedRoute, private summaryService: SummaryService,
    private sharedService: SharedService, private changeDetectorRef: ChangeDetectorRef, private notificationService: NotificationService) {
    this.menuList = this.ocadoAuthService.privilege.filter(list => list.is_menu_item === 'Y').
      map(menu => ({ text: menu.sreen_label, active: false, url: menu.screen_url }));
    this.reportsList = this.ocadoAuthService.privilege.filter(list => list.is_reports === 'Y').
      map(menu => ({ text: menu.sreen_label, active: false, url: menu.screen_url }));
    this.indexedDBService.initDB();
  }
  ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    if (this.ocadoAuthService.privilege.find(p => [ 'manage-invoice' ].includes(p.screen_id)) && this.ocadoAuthService.roleIdList.includes('PROMO_FINANCE')) {
      this.tabsList.splice(2, 0, { active: false, text: "Manage Invoice", url: "manage-invoice", routeParam: [ { qi: this.filterQuery } ] });
    }
    if (this.router.url === '/') {
      if (this.ocadoAuthService.isStaff) {
        if (this.ocadoAuthService.privilege.find(p => p.screen_id === 'buyer-dashboard')) {
          this.router.navigate([ 'buyer-dashboard' ]);
        } else if (this.ocadoAuthService.privilege.find(p => [ 'manage-invoice' ].includes(p.screen_id)) && this.ocadoAuthService.roleIdList.includes('PROMO_FINANCE')) {
          this.clickMenu({ active: true, text: "Manage Invoice", url: "manage-invoice" });
        } else {
          const defaultView = this.menuItems.find(view => view.is_default === 'Y');
          let filterQuery = '';
          let columnQuery: string | null = '';
          if (defaultView) {
            filterQuery = defaultView.search_criteria;
            columnQuery = defaultView.show_hide_columns;
          } else {
            filterQuery = sessionStorage.getItem('summary') || btoa(JSON.stringify(promotionConstants.defaultFilter));
            columnQuery = sessionStorage.getItem('show_hide_columns') ? sessionStorage.getItem('show_hide_columns') : (this.ocadoAuthService.isStaff ? btoa(JSON.stringify(promotionConstants.buyerColumnsList.map((e: any) => ({ id: e.id, isVisible: e.isVisible })))) : btoa(JSON.stringify(promotionConstants.supplierColumnsList.map((e: any) => ({ id: e.id, isVisible: e.isVisible }))))) || '';
          }
          this.router.navigate([ '/summary' ], {
            queryParams: {
              q: filterQuery, col: columnQuery
            }
          });
        }
      } else {
        this.router.navigate([ 'supplier-dashboard' ]);
      }
    }
    // if (this.ocadoAuthService.isStaff) {
    if (!this.ocadoAuthService.privilege.find(p => [ 'buyer-dashboard', 'supplier-dashboard' ].includes(p.screen_id))) {
      this.tabsList = this.tabsList.slice(1);
    }
    // }
    this.tabScreenLimitReachedSubscription = this.tabScreenLimitReached.valueChanges.pipe(startWith(this.tabScreenLimitReached.value)).subscribe(data => this.tabScreenLimitReachedMsg = 'of permitted ' + data + ' tabs. If you want to open a new tab, please close one.');
    this.newTabSubscription = this.sharedService.newTab.subscribe(data => {
      if (data) {
        const previousTab = this.tabsList.find(value => data.id && +value.id === +data.id);
        if (!previousTab) {
          if (this.tabsList.filter(value => value.url === data.url).length !== 5) {
            this.tabsList.forEach((value: any) => {
              value.active = false;
            });
            this.tabsList.push(data);
            this.tabLimitReached = false;
            this.tabScreenLimitReached.setValue('');
            this.router.navigate(
              [ '/' + data.url ],
              { queryParams: data.routeParam[ 0 ] }
            ).finally(() => {
              this.summaryService.reloadWizard.next(false);
            });
          } else {
            this.tabLimitReached = true;
            this.tabScreenLimitReached.setValue(data.url.replace('-', ' '));
          }
        } else {
          this.tabsList.forEach((value: any) => {
            value.active = false;
          });
          previousTab.active = true;
          this.router.navigate(
            [ '/' + data.url ],
            { queryParams: data.routeParam[ 0 ] }
          );
        }
        this.sharedService.tabLimitExceed.next(this.tabLimitReached);
      }
    });

    this.routerEventsSubscription = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url)
    ).subscribe(url => {
      this.activeTab(url);
    });

    this.queryParamsSubscription = this.activatedRoute.queryParams.pipe(
      filter(data => data[ 'proposal_id' ] || data[ 'promotion_id' ] || data[ 'q' ])
    ).subscribe(data => {
      const url = this.router.url;
      this.tabsList.forEach((value: any) => {
        value.active = false;
      });
      let routeParam;
      let result = url.slice(1);
      const paramIndex = result.indexOf('?');
      if (paramIndex > -1) {
        routeParam = result.split('?')[ 1 ];
        result = result.split('?')[ 0 ];
      }
      if (data[ 'v' ]) {
        this.previousRouteIndex = this.tabsList.findIndex((menu: any) => menu.url === result && menu.text ===
          JSON.parse(atob(data[ 'v' ])).name);
        // console.log("previousRouteIndex", data, this.tabsList, this.previousRouteIndex);
      } else {
        this.previousRouteIndex = this.tabsList.findIndex((menu: any) => menu.url === result);
      }
      if (this.previousRouteIndex < 0) {
        if (this.tabsList.filter(value => value.url === result).length !== 5) {
          if (data[ 'v' ]) {
            this.tabsList.push({
              text: JSON.parse(atob(data[ 'v' ])).name,
              url: result,
              routeParam: [ data ],
              active: true
            });
          } else {
            this.tabsList.push({
              text: data[ 'proposal_id' ] ? 'Create Proposal' : 'Create Promotion',
              url: result,
              id: routeParam?.split('=')[ 1 ],
              routeParam: [ data ],
              active: true
            });
          }
          this.tabLimitReached = false;
          this.tabScreenLimitReached.setValue('');
        } else {
          this.tabLimitReached = true;
          this.tabScreenLimitReached.setValue(result.replace('-', ' '));
        }
        this.sharedService.tabLimitExceed.next(this.tabLimitReached);
        // }
      } else {
        if (!url.includes('proposal_id') && !url.includes('promotion_id')) {
          this.tabsList[ this.previousRouteIndex ].active = true;
          this.tabsList[ this.previousRouteIndex ].routeParam = [ data ];
        }
      }
    });
    this.promotionNameSubscription = this.sharedService.promotionName
      .subscribe(value => {
        if (value.length > 0) {
          const data = value.find(v => v.isEdited);
          const index = this.tabsList.findIndex(d => Number(d.id) === Number(data?.id));
          this.tabsList[ index ].text = data?.name;
          this.tabsList.forEach((value: any) => {
            value.active = false;
          });
          this.tabsList[ index ].active = true;
        }
        this.warningDialog = false;
      });

    this.deleteTabSubscription = this.sharedService.deleteTab.subscribe(data => {
      if (data) {
        const index = this.tabsList.findIndex(value => value.active);
        if (this.tabsList[ index ].text !== 'Summary') {
          if (index >= 0) {
            this.tabsList.splice(index, 1);
            this.tabClickEvent(this.tabsList[ index - 1 ], index - 1);
          }
        }
        this.sharedService.deleteTab.next(false);
      }
    });

    this.currentViewIdSubscription = this.sharedService.currentViewId.subscribe(id => {
      if (id > 0) {
        this.currentViewId = id;
      }
    });

    this.activeTab(this.router.url);
    this.invalidProposalSubscription = this.sharedService.invalidProposal.subscribe(data => {
      this.draftStatus = data;
    });
    this.checkFormChangeSubscription = this.sharedService.checkFormChange.subscribe(data => this.isFormChange = data);
    this.summaryService.allViews.subscribe(data => {
      this.menuItems = [ {
        "search_id": Math.random(),
        "search_name": "Unfiltered view",
        "is_default": "N",
        "search_criteria": this.filterQuery,
        "show_hide_columns": btoa(JSON.stringify(this.tempColumn.map((e: any) => ({ id: e.id, isVisible: e.isVisible }))))
      }, ...data ];
      if (data.length) {
        if (this.currentViewId > -1) {
          const menu = this.menuItems.find(view => view?.search_id === this.currentViewId);
          const index = this.tabsList.findIndex(tab => tab.active);
          if (this.tabsList[ index ].text !== menu?.search_name && this.tabsList[ index ].text !== 'Summary') {
            this.tabsList[ index ].text = menu?.search_name;
            this.router.navigate([], {
              queryParams: { v: btoa(JSON.stringify({ name: menu?.search_name })) },
              queryParamsHandling: 'merge'
            });
          }
        }
      }

    });
    this.summaryService.fetchView();
  }

  clickView(menu: any) {
    // this.tabsList.forEach((value: any) => {
    //   value.active = false;
    // });
    // const index = this.tabsList.findIndex(tab => tab.text === menu.search_name);
    // if (index === -1) {
    //   this.tabsList.push({
    //     text: menu.search_name,
    //     url: 'summary',
    //     active: true,
    //     id: menu.search_id,
    //     routeParam: [ { q: menu.search_criteria, col: menu.show_hide_columns } ]
    //   });
    // } else {
    //   this.tabsList[ index ].active = true;
    //   this.tabsList[ index ].routeParam = [ { q: menu.search_criteria, col: menu.show_hide_columns } ];
    // }
    // if (menu.is_default === 'Y') {
    //   sessionStorage.setItem("summary", menu.search_criteria);
    // }
    this.router.navigate([ 'summary' ], {
      queryParams: {
        q: menu.search_criteria, col: menu.show_hide_columns, v: btoa(JSON.stringify({ name: menu.search_name.trim() }))
      }
    });
    this.plusDialog = false;

  }

  clickMenu(menu: any) {
    console.log(menu, 'menu');
    this.tabsList.forEach((value: any) => {
      value.active = false;
    });
    const index = this.tabsList.findIndex(tab => tab.text === menu.text);
    if (index === -1) {
      menu.active = true;
      menu.url.includes('manage-invoice') ? this.tabsList.push({ ...menu, routeParam: [ { qi: this.filterQuery } ] }) : menu.url.includes('manage-customer-group') ? this.tabsList.push({ ...menu, routeParam: [ { qcg: this.filterQuery } ] }) :
        menu.url.includes('rule-editor') ? this.tabsList.push({ ...menu, routeParam: [ { qre: this.filterQuery } ] }) :
          menu.url.includes('customer-group-requests') ? this.tabsList.push({ ...menu, routeParam: [ { qcgR: this.filterQuery } ] }) : this.tabsList.push(menu);
    } else {
      this.tabsList[ index ].active = true;
    }
    // console.log(this.router.url, menu.url);
    menu.url.includes('manage-invoice') ? this.router.navigate([ menu.url ], { queryParams: { qi: this.filterQuery } }) : menu.url.includes('manage-customer-group') ? this.router.navigate([ menu.url ], { queryParams: { qcg: this.filterQuery } }) : menu.url.includes('rule-editor') ? this.router.navigate([ menu.url ], { queryParams: { qre: this.filterQuery } }) : menu.url.includes('customer-group-requests') ? this.router.navigate([ menu.url ], { queryParams: { qcgR: this.filterQuery } }) : this.router.navigate([ menu.url ]);
    this.plusDialog = false;
  }

  onClickDefaultBtn(item: any) {
    this.clickedItem = item;
    const payload = {
      search_id: item.search_id,
      search_name: item.search_name,
      is_default: 'Y',
      search_criteria: item.search_criteria,
      show_hide_columns: item.show_hide_columns
    };
    this.summaryService.saveView(payload).subscribe(() => {
      this.summaryService.fetchView();
      this.menuBar?.refresh();
      sessionStorage.setItem('summary', payload.search_criteria);
      this.router.navigate([ '/summary' ], { queryParams: { q: payload.search_criteria, col: payload.show_hide_columns } });
      this.plusDialog = false;
    });
  }


  clickPlus(args: MouseEvent) {
    args.stopPropagation();
    this.plusDialog = !this.plusDialog;
    this.dialogLeft = args.x - 30;
  }

  preventDialogClose(args: MouseEvent) {
    args.stopPropagation();
  }

  activeTab(url: string) {
    let result = url.slice(1);
    const paramIndex = result.indexOf('?');
    let previousRouteIndexes;
    if (paramIndex > -1) {
      result = result.split('?')[ 0 ];
      // console.log(this.tabsList, url.slice(1).split('?')[ 1 ], result);
      this.previousRouteIndex = this.tabsList.findIndex((menu: any) => menu.url === result && (menu.routeParam[ 0 ].q === url.slice(1).split('?q=')[ 1 ]));
      previousRouteIndexes = this.tabsList.findIndex((menu: any) => menu.url === result && (menu.routeParam[ 0 ].q === url.slice(1).split('?qi=')[ 1 ]));
    } else {
      this.previousRouteIndex = this.tabsList.findIndex((menu: any) => menu.url === result);
    }
    if (this.previousRouteIndex < 0) {
      if (url.includes('notification')) {
        this.tabsList.forEach((value: any) => {
          value.active = false;
        });
        this.tabsList.push({
          text: 'Notification',
          url: 'notification',
          active: true
        });
      }
      const menu = this.menuList.find(menu => url.includes(menu.url)) ? this.menuList.find(menu => url.includes(menu.url)) : this.reportsList.find(menu => url.includes(menu.url));
      if (menu) {
        this.tabsList.forEach((value: any) => {
          value.active = false;
        });
        menu.active = true;
        this.tabsList.push(menu);
      }
    } else if (previousRouteIndexes && previousRouteIndexes > 0) {
      if (!url.includes('proposal_id') && !url.includes('promotion_id')) {
        this.tabsList.forEach((value: any) => {
          value.active = false;
        });
        this.tabsList[ previousRouteIndexes ].active = true;
      }
    }
    else {
      if (!url.includes('proposal_id') && !url.includes('promotion_id')) {
        this.tabsList.forEach((value: any) => {
          value.active = false;
        });
        this.tabsList[ this.previousRouteIndex ].active = true;
      }
    }
  }

  ngAfterViewInit(): void {
    // const eventNames = [ 'count' ];
    // this.connectToServerSentEventsSubscription = this.notificationService.connectToServerSentEvents(eventNames).subscribe((result: any) => {
    //   const countData = JSON.parse(result.data);
    //   this.notificationService.notificationCount.next(countData.count);
    // });

    this.notificationService.setupSocketConnection();
    this.notificationService.notificationCount.subscribe();

    this.getApplicationListSubscription = this.sharedService.getApplicationList().subscribe(data => {
      const applicationList = data.result;
      this.sharedService.activeApplicationDetails.next(applicationList);
    });

  }

  btnTrigger() {
    this.tabLimitReached = false;
    this.tabScreenLimitReached.setValue('');
  }

  // selectMenuItem(event: MenuEventArgs) {
  //   if (this.previousRouteIndex >= 0) {
  //     // this.menuBar.element.children[ this.previousRouteIndex ].classList.remove('menu-active');
  //   }
  //   if (event.item.text !== '+') {
  //     // this.router.navigate([ event.item.url ]);
  //   } else {
  //     // this.menuBar.element.children[ this.previousRouteIndex ].classList.add('menu-active');
  //   }
  // }

  tabClickEvent(tab: any, index: number) {
    const routeParam = tab.routeParam;
    if (routeParam) {
      if (routeParam[ 0 ][ 'v' ]) {
        this.router.navigate([ '/' + tab.url ], { queryParams: routeParam[ 0 ] });
      } else {
        if (tab.url.includes('summary')) {
          const defaultView = this.menuItems.find(view => view.is_default === 'Y');
          let columnQuery: string | null = '';
          if (defaultView) {
            columnQuery = defaultView.show_hide_columns;
          } else {
            columnQuery = sessionStorage.getItem('show_hide_columns') ? sessionStorage.getItem('show_hide_columns') : (this.ocadoAuthService.isStaff ? btoa(JSON.stringify(promotionConstants.buyerColumnsList.map((e: any) => ({ id: e.id, isVisible: e.isVisible })))) : btoa(JSON.stringify(promotionConstants.supplierColumnsList.map((e: any) => ({ id: e.id, isVisible: e.isVisible }))))) || '';
          }
          // let filterQuery = '';
          const filterQuery = sessionStorage.getItem('summary') ? sessionStorage.getItem('summary') : defaultView ? defaultView.search_criteria : btoa(JSON.stringify(promotionConstants.defaultFilter));
          this.router.navigate([ '/summary' ], { queryParams: { q: filterQuery, col: columnQuery } });
        } else if (tab.url.includes('manage-invoice')) {
          // const invoiceQuery = this.tabsList.find(tab => tab.url === 'manage-invoice');
          this.router.navigate([ '/manage-invoice' ], { queryParams: { qi: sessionStorage.getItem('invoiceQuery') ? sessionStorage.getItem('invoiceQuery') : btoa(JSON.stringify(promotionConstants.defaultFilter)) } });
        } else {
          this.router.navigate([ '/' + tab.url ], { queryParams: routeParam[ 0 ] });
        }
      }
    } else {
      this.router.navigate([ '/' + tab.url ]);
    }
    this.tabsList.forEach((value: any) => {
      value.active = false;
    });
    this.tabsList[ index ].active = true;
    this.notificationService.notificationCommentsTab.next(0);
  }

  closeTab(index: number) {
    this.closeIndex = index;
    if (this.tabsList[ index ].url === 'promotion-detail' || this.tabsList[ index ].url === 'proposal-detail') {
      this.sharedService.resetSessionStorageSearch(this.tabsList[ index ].id);
      if (this.tabsList[ index ].url === 'promotion-detail') {
        this.indexedDBService.deleteData(this.tabsList[ index ].id, promotionConstants.promotionsStoreName);
      } else {
        this.indexedDBService.deleteData(this.tabsList[ index ].id, promotionConstants.proposalsStoreName);
      }
    }
    if (this.router.url === '/rule-editor') sessionStorage.removeItem('rule-grid-sort');
    else if (this.router.url === '/notification') sessionStorage.removeItem('NOTI_PAGE_SIZE');
    else if (this.router.url.includes('manage-invoice')) sessionStorage.removeItem('invoiceQuery');
    // else if (this.router.url.includes('manage-customer-group')) sessionStorage.removeItem('customerGrpQuery');
    else if (this.router.url.includes('customer-group-requests')) sessionStorage.removeItem('customerGrpReqQuery');
    if (!this.draftStatus || this.router.url === '/bulk-upload' || this.router.url === "/notification") {
      this.discard();
    } else {
      if (this.isFormChange) {

        this.warningDialog = true;
      } else {
        this.discard();
      }
    }
  }

  resumeEdit() {
    this.warningDialog = false;
  }

  discard() {
    this.warningDialog = false;
    const index = this.closeIndex === this.tabsList.length - 1 ? this.closeIndex - 1 : this.closeIndex;
    this.tabsList.splice(this.closeIndex, 1);
    this.tabClickEvent(this.tabsList[ index ], index);
  }

  // handleSelectDefault(selectedView: any) {
  //   selectedView = {
  //     "viewName": "sdfsdf",
  //     "defaultView": true,
  //     "filter": [
  //       {
  //         "condition": "and",
  //         "field": "status",
  //         "operator": "Equal",
  //         "type": "string",
  //         "value": "Submitted",
  //         "display_field": "Proposal Status",
  //         "display_value": "Submitted",
  //         "operator_lov_code": "LOV_GROUP_FIXED"
  //       }
  //     ],
  //     "sort": {
  //       "field": null,
  //       "display_field": "",
  //       "type": null
  //     },
  //     "pagination": {
  //       "page_number": 1,
  //       "page_size": 30
  //     },
  //     "reqCount": true,
  //     "change_post_extraction": false,
  //   };
  //   // this.viewService.setSelectedView(selectedView);

  //   this.filtrationFormGroup = this.createFormGroup(selectedView);
  //   this.saveFilterDialog.show();
  //   // const filterQuery = btoa(JSON.stringify(this.filtrationFormGroup.value));
  //   // this.summaryService.gridFilterComponentBh.next(false);
  //   // this.summaryService.hideFilterDialog.next(false);
  //   // }
  // }

  // handleSaveFilter() {
  //   this.saveFilterDialog.hide();
  // }

  ngOnDestroy(): void {
    // this.notificationCount.unsubscribe();
    this.notificationService.close();
    this.tabScreenLimitReachedSubscription?.unsubscribe();
    this.newTabSubscription?.unsubscribe();
    this.routerEventsSubscription?.unsubscribe();
    this.queryParamsSubscription?.unsubscribe();
    this.promotionNameSubscription?.unsubscribe();
    this.deleteTabSubscription?.unsubscribe();
    this.invalidProposalSubscription?.unsubscribe();
    this.checkFormChangeSubscription?.unsubscribe();
    // this.connectToServerSentEventsSubscription?.unsubscribe();
    this.getApplicationListSubscription?.unsubscribe();
    this.menuBar?.destroy();
    this.notificationService.disconnect();
  }

  // private createFormGroup(data?: Filtration): FormGroup<filtrationFormGroup> {
  //   return new FormGroup<filtrationFormGroup>({
  //     filter: this.createFilterFormGroup(data?.filter || []),
  //     sort: this.createSortFormGroup(data?.sort as Sort),
  //     pagination: this.createPaginationFormGroup(data?.pagination as Pagination),
  //     reqCount: new FormControl(data?.reqCount ? data?.reqCount : false, { nonNullable: true }),
  //     change_post_extraction: new FormControl(data?.change_post_extraction ? data?.change_post_extraction : false, { nonNullable: true }),
  //   });
  // }
  // private createFilterFormGroup(value: Filter[]): FormArray<FormGroup<FilterFormGroup>> {
  //   const fromArray = value.map(data => new FormGroup<FilterFormGroup>({
  //     condition: new FormControl(data?.condition ? data?.condition : '', { nonNullable: true }),
  //     field: new FormControl(data?.field ? data?.field : '', { nonNullable: true }),
  //     operator: new FormControl(data?.operator ? data?.operator : '', { nonNullable: true }),
  //     type: new FormControl(data?.type ? data?.type : '', { nonNullable: true }),
  //     value: new FormControl(data?.value ? data?.value : '', { nonNullable: true, validators: [ Validators.required ] }),
  //     display_field: new FormControl(data?.display_field ? data?.display_field : '', { nonNullable: true }),
  //     display_value: new FormControl(data?.display_value ? data?.display_value : '', { nonNullable: true }),
  //     operator_lov_code: new FormControl(data?.operator_lov_code ? data?.operator_lov_code : '', { nonNullable: true }),
  //   }, {
  //     validators: [ FilterValidators.noWhiteSpace, FilterValidators.noBetweenSpace, FilterValidators.requiredValue ]
  //   }));
  //   return new FormArray<FormGroup<FilterFormGroup>>(fromArray);
  // }
  // private createSortFormGroup(data: Sort) {
  //   return new FormGroup<SortFormGroup>({
  //     field: new FormControl(data?.field ? data?.field : null, { nonNullable: true }),
  //     display_field: new FormControl(data?.display_field ? data?.display_field : '', { nonNullable: true }),
  //     type: new FormControl(data?.type ? data?.type : null, { nonNullable: true }),
  //   });
  // }
  // private createPaginationFormGroup(data: Pagination) {
  //   return new FormGroup<PaginationFormGroup>({
  //     page_number: new FormControl(data?.page_number ? data?.page_number : null, { nonNullable: true }),
  //     page_size: new FormControl(data?.page_size ? data?.page_size : null, { nonNullable: true }),
  //   });
  // }
}